// extracted by mini-css-extract-plugin
module.exports = {"camp-I":"I_camp-I__SOY2V"};